const ENABLE_GOOGLE_ANALYTICS_TRACKING = true;
const ENABLE_MATOMO_TRACKING = true;
/**
 * Execute a callback with the global `gtag` function if GA is present.
 */ function invokeGtag(callback) {
    const { gtag } = window;
    if (gtag) {
        callback(gtag);
    }
}
/**
 * Execute a callback with the Matomo queue if `_paq` is available.
 */ function invokeMatomo(callback) {
    const { _paq } = window;
    if (_paq) {
        callback(_paq);
    }
}
function configureMatomoHeatmapSessionRecordingForVirtualPageViews() {
    if (!ENABLE_MATOMO_TRACKING) {
        return;
    }
    invokeMatomo((paq)=>{
        paq.push([
            "HeatmapSessionRecording::disableAutoDetectNewPageView"
        ]);
        paq.push([
            "HeatmapSessionRecording::matchTrackerUrl"
        ]);
    });
}
/**
 * Track an analytics event in GA and Matomo using explicit params per system.
 */ function trackAnalyticsEvent(eventName, params) {
    const gaParams = params?.ga;
    const matomoParams = params?.matomo;
    if (ENABLE_GOOGLE_ANALYTICS_TRACKING && gaParams) {
        invokeGtag((gtag)=>gtag("event", eventName, gaParams));
    }
    if (ENABLE_MATOMO_TRACKING && matomoParams) {
        invokeMatomo((paq)=>{
            const { category, name, value } = matomoParams;
            paq.push([
                "trackEvent",
                category,
                eventName,
                name,
                value
            ]);
        });
    }
}
function trackMatomoEcommerceView({ productSKU, productName, categoryName, price }) {
    if (!ENABLE_MATOMO_TRACKING) {
        return;
    }
    invokeMatomo((paq)=>{
        // Matomo ecommerce product views require a regular page view after setEcommerceView.
        paq.push([
            "setEcommerceView",
            productSKU,
            productName,
            categoryName,
            price
        ]);
        paq.push([
            "trackPageView"
        ]);
    });
}
function trackMatomoEcommerceItem({ productSKU, productName, categoryName, price }) {
    if (!ENABLE_MATOMO_TRACKING) {
        return;
    }
    invokeMatomo((paq)=>{
        // Quantity is fixed to 1 because this checkout does not support multi-item carts.
        paq.push([
            "addEcommerceItem",
            productSKU,
            productName,
            categoryName,
            price,
            1
        ]);
    });
}
function trackMatomoEcommerceCartUpdate(grandTotal) {
    if (!ENABLE_MATOMO_TRACKING || typeof grandTotal !== "number") {
        return;
    }
    invokeMatomo((paq)=>{
        paq.push([
            "trackEcommerceCartUpdate",
            grandTotal
        ]);
    });
}
function trackMatomoEcommerceOrder({ orderId, grandTotal, subTotal, tax, shipping, discount }) {
    if (!ENABLE_MATOMO_TRACKING || !orderId || typeof grandTotal !== "number") {
        return;
    }
    invokeMatomo((paq)=>{
        paq.push([
            "trackEcommerceOrder",
            orderId,
            grandTotal,
            subTotal,
            tax,
            shipping,
            discount
        ]);
    });
}
function clearMatomoEcommerceCart() {
    if (!ENABLE_MATOMO_TRACKING) {
        return;
    }
    invokeMatomo((paq)=>{
        paq.push([
            "clearEcommerceCart"
        ]);
    });
}
function trackMatomoPageView({ customUrl, documentTitle, referrerUrl }) {
    if (!ENABLE_MATOMO_TRACKING || !customUrl) {
        return;
    }
    invokeMatomo((paq)=>{
        if (referrerUrl) {
            paq.push([
                "setReferrerUrl",
                referrerUrl
            ]);
        }
        paq.push([
            "setCustomUrl",
            customUrl
        ]);
        if (documentTitle) {
            paq.push([
                "setDocumentTitle",
                documentTitle
            ]);
        }
        paq.push([
            "HeatmapSessionRecording::setNewPageView",
            true
        ]);
        paq.push([
            "trackPageView"
        ]);
    });
}
function buildMatomoEventNameWithProductMeta(baseName, productMeta) {
    const { product_id, product_plan_id, product_name } = productMeta;
    return `${baseName} | product_id=${product_id} | product_plan_id=${product_plan_id} | product_name=${product_name}`;
}
export { configureMatomoHeatmapSessionRecordingForVirtualPageViews, buildMatomoEventNameWithProductMeta, ENABLE_GOOGLE_ANALYTICS_TRACKING, ENABLE_MATOMO_TRACKING, clearMatomoEcommerceCart, invokeGtag, invokeMatomo, trackAnalyticsEvent, trackMatomoEcommerceCartUpdate, trackMatomoEcommerceItem, trackMatomoEcommerceOrder, trackMatomoPageView, trackMatomoEcommerceView };
